import { LitElement, html } from 'lit';

class BeautyProductTile extends LitElement {
  static get properties() {
    return {
      productId: { type: Number, attribute: 'product_id' },
      productHandle: { type: String, attribute: 'product_handle' },
      productTitle: { type: String, attribute: 'product_title' },
      productImage: { type: String, attribute: 'product_image' },
      productPrice: { type: String, attribute: 'product_price' },
      productComparePrice: { type: String, attribute: 'product_compare_price' },
      productVendor: { type: String, attribute: 'product_vendor' },
      productAvailable: { type: String, attribute: 'product_available' },
      variantId: { type: Number, attribute: 'variant_id' },
      currencySymbol: { type: String, attribute: 'currency_symbol' },
      currencyCode: { type: String, attribute: 'currency_code' },
      productTags: { type: String, attribute: 'product_tags' },
      siblingsData: { type: String, attribute: 'siblings_data' },
      variantsData: { type: String, attribute: 'variants_data' },
      variantType: { type: String, attribute: 'variant_type' },
      isLoading: { type: Boolean }
    };
  }

  constructor() {
    super();
    this.productId = 0;
    this.productHandle = '';
    this.productTitle = '';
    this.productImage = '';
    this.productPrice = '0';
    this.productComparePrice = '0';
    this.productVendor = '';
    this.productAvailable = 'true';
    this.variantId = 0;
    this.currencySymbol = '$';
    this.currencyCode = 'AUD';
    this.productTags = '';
    this.siblingsData = '[]';
    this.variantsData = '[]';
    this.variantType = 'siblings';
    this.isLoading = false;
  }

  createRenderRoot() { return this; }

  connectedCallback() {
    super.connectedCallback();
    if (this.variantId === 0 && this.variantsData !== '[]') {
      const [first] = JSON.parse(this.variantsData || '[]').filter(v => v.available && v.option1);
      if (first) Object.assign(this, { variantId: first.id, productPrice: first.price || this.productPrice, productComparePrice: first.compare_at_price || this.productComparePrice, productAvailable: first.available.toString() });
    }
  }

  async handleAddToCart() {
    if (this.productAvailable !== 'true' || !this.variantId || this.isLoading) return;

    this.isLoading = true;
    this.requestUpdate();

    try {
      await window.cartUtils.addItem(this.variantId, 1);
      window.drawerFunctions?.toggleDrawer('drawer_sidecart', true);
    } catch (error) {
      console.error('Error adding to cart:', error);
    }

    this.isLoading = false;
    this.requestUpdate();
  }

  get isOnSale() {
    return parseFloat(this.productComparePrice) > parseFloat(this.productPrice);
  }

  get formattedPrice() {
    const price = parseFloat(this.productPrice);
    if (isNaN(price)) return this.currencySymbol + '0.00 ' + this.currencyCode;
    return `${this.currencySymbol}${price.toFixed(2)} ${this.currencyCode}`;
  }

  get formattedComparePrice() {
    const price = parseFloat(this.productComparePrice);
    if (isNaN(price) || price === 0) return '';
    
    return `${this.currencySymbol}${price.toFixed(2)}`;
  }

  render() {
    const handleSelect = (e) => {
      const sibling = e.detail?.sibling;
      const variant = e.detail?.variant;
      
      if (sibling) {
        // Handle sibling selection (colors)
        if (sibling.handle) this.productHandle = sibling.handle;
        if (sibling.image) this.productImage = sibling.image;
        if (sibling.price) this.productPrice = sibling.price;
        if (sibling.title) this.productTitle = sibling.title;
        if (sibling.variant_id) this.variantId = sibling.variant_id;
      } else if (variant) {
        // Handle variant selection (sizes)
        this.variantId = variant.id;
        if (variant.price) this.productPrice = variant.price;
        if (variant.compare_at_price) this.productComparePrice = variant.compare_at_price;
        // Update availability based on selected variant
        this.productAvailable = variant.available.toString();
      }
      
      this.requestUpdate();
    };

    return html`
      <div class="beauty_product_tile">
        <a href="/products/${this.productHandle}">
          <img src="${this.productImage}" alt="${this.productTitle}" loading="lazy">
          <h3>${this.productTitle}</h3>
          <div class="price">${this.formattedPrice}</div>
        </a>
        
        <beauty-siblings
          product_id="${this.productId}"
          product_handle="${this.productHandle}"
          product_tags="${this.productTags || ''}"
          siblings_data='${this.siblingsData || "[]"}'
          variants_data='${this.variantsData || "[]"}'
          current_variant_id="${this.variantId}"
          @beauty:sibling-select=${handleSelect}
          @beauty:variant-select=${handleSelect}
        ></beauty-siblings>
        
        <button class="beauty_add_to_cart" @click=${this.handleAddToCart} ?disabled=${this.isLoading || this.productAvailable !== 'true'}>
          ${this.isLoading ? html`<bouncing-ellipsis></bouncing-ellipsis>` : 
            this.productAvailable === 'true' ? '+ADD TO BAG' : 'SOLD OUT'}
        </button>
      </div>
    `;
  }
}

customElements.define('beauty-product-tile', BeautyProductTile);